export function BMPGL() {
  return new Promise(function (resolve, reject) {
    window.init = function () {
      resolve(window.BMapGL)
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `http://api.map.baidu.com/api?v=1.0&type=webgl&ak=buUaqCB4BTZvQsR2WS6Vw889G8ezPh1V&callback=init`
    script.onerror = reject
    document.head.appendChild(script);
  })
}
// function weather() {
//   return weatherData;
// }

// export {
//   weather
// }